// Navigation.js
import LogoImage from '../../src/images/nopsa_logo.png';
import scroll from "../utils/scroll";
import { useNavigate } from "../router";

export const Navigation = (props) => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    navigate("/");
    // Ensure we scroll to top after route change
    setTimeout(() => scroll.animateScroll(0), 0);
    // Clear hash from URL without reloading
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, "/");
    }
    closeMenu();
  };

  const handleNavClick = (e, section) => {
    e.preventDefault();
    navigate("/");
    setTimeout(() => {
      const target = section ? document.getElementById(section) : null;
      if (target) {
        scroll.animateScroll(target, { offset: 58 });
      } else {
        scroll.animateScroll(0);
      }
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, "/");
      }
    }, 20);
    closeMenu();
  };

  const closeMenu = () => {
    const menu = document.getElementById('bs-navbar-collapse');
    if (menu) {
      menu.classList.remove('in');
      menu.classList.remove('show');
    }
    const toggle = document.querySelector('.navbar-toggle');
    if (toggle) {
      toggle.classList.add('collapsed');
      toggle.setAttribute('aria-expanded', 'false');
    }
  };

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top align-right'>
      <div className='container'>
        <div className='navbar-header'>
          <img src={LogoImage} alt="Logo" className="logo-image" onClick={scrollToTop} />
          <span id="menu-title" className="logo-text" onClick={scrollToTop}>Nopsa Ventures</span>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-navbar-collapse'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
        </div>
        <div
          className='collapse navbar-collapse '
          id='bs-navbar-collapse'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='/' className='page-scroll' onClick={(e) => handleNavClick(e, 'services')}>
                Services
              </a>
            </li>
            <li>
              <a href='/' className='page-scroll' onClick={(e) => handleNavClick(e, 'about')}>
                About
              </a>
            </li>
            <li>
              <a href='/' className='page-scroll' onClick={(e) => handleNavClick(e, 'products')}>
                Products
              </a>
            </li>
            <li>
              <a href='/blog' className='page-scroll' onClick={(e) => { e.preventDefault(); navigate('/blog'); closeMenu(); }}>
                Blog
              </a>
            </li>
            <li>
              <a href='/' className='page-scroll' onClick={(e) => handleNavClick(e, 'testimonials')}>
                Testimonials
              </a>
            </li>
            <li>
              <a href='/' className='page-scroll' onClick={(e) => handleNavClick(e, 'contact')}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
